//import "../Header/Header.css";
function Header(){
    return(
        <div className="text-white text-center py-3" id="headerContainer">Tasks Completed</div>
    )
}

export default Header;